export default {
    props: {
        ratio: {
            type: [String, Number, Boolean],
            required: false,
            default: false
        },
        'mobile-ratio': {
            type: [String, Boolean],
            required: false,
            default: false
        },
        breakpoint: {
            type: [String, Number],
            required: false,
            default: 960
        }
    },
    computed: {
        ratio_classes() {
            return {
                'bxs-r': this.local_ratio && this.local_ratio.length > 0,
                'bxs-r-1-1': this.local_ratio === '1/1' || this.local_ratio === '1',
                'bxs-r-16-9': this.local_ratio === '16/9',
                'bxs-r-2-1': this.local_ratio === '2/1',
                'bxs-r-2-3': this.local_ratio === '2/3',
                'bxs-r-21-4': this.local_ratio === '21/4',
                'bxs-r-21-9': this.local_ratio === '21/9',
                'bxs-r-3-4': this.local_ratio === '3/4',
                'bxs-r-4-1': this.local_ratio === '4/1',
                'bxs-r-4-3': this.local_ratio === '4/3',
                'bxs-r-4-5': this.local_ratio === '4/5' || this.local_ratio === 'facebook',
                'bxs-r-9-16': this.local_ratio === '9/16',
                'bxs-r-reel': this.local_ratio === 'reel'
            }
        }
    },
    data() {
        return {
            local_ratio: this.ratio
        }
    },
    watch: {
        ratio(newVal) {
            this.local_ratio = newVal
        }
    }
}
